import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const VirusFoundIcon = forwardRef<SVGSVGElement, IconProps>(function VirusFoundIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1301 4.59171C16.3753 5.61495 16.4872 6.95066 16.4993 8.711C16.5006 8.90101 16.4992 8.91586 16.497 8.93563L16.4969 8.93659C16.4946 8.95763 16.4935 8.96848 16.4576 9.12565C15.3245 14.0961 11.2503 15.9816 9.44284 16.5906C9.34365 16.624 9.28287 16.6444 9.23027 16.6606C9.18228 16.6754 9.15895 16.6811 9.14712 16.6836C9.14681 16.6837 9.14644 16.6838 9.146 16.6839C9.138 16.6857 9.10761 16.6927 9 16.6927C8.89239 16.6927 8.862 16.6857 8.854 16.6839C8.85356 16.6838 8.85319 16.6837 8.85288 16.6836C8.84105 16.6811 8.81772 16.6754 8.76972 16.6606C8.71713 16.6444 8.65635 16.624 8.55715 16.5906C6.74968 15.9816 2.67546 14.0961 1.54237 9.12564C1.50654 8.96847 1.50536 8.95763 1.50306 8.93658L1.50296 8.93563C1.5008 8.91586 1.49937 8.90101 1.50068 8.711C1.51284 6.95066 1.62465 5.61495 1.86987 4.5917C2.1132 3.57635 2.46784 2.9561 2.89429 2.54573C3.73802 1.73382 5.32468 1.30733 9 1.30733C12.6753 1.30733 14.262 1.73382 15.1057 2.54573C15.5322 2.9561 15.8868 3.57635 16.1301 4.59171ZM17.9904 9.0597C17.9796 9.15843 17.9627 9.23242 17.929 9.38039C16.654 14.9734 12.0287 17.121 9.98378 17.81C9.60781 17.9367 9.41982 18 9 18C8.58018 18 8.39219 17.9367 8.01622 17.81C5.97135 17.121 1.34603 14.9734 0.0710389 9.38039C0.0373083 9.23244 0.0204402 9.15843 0.00963918 9.0597C-0.00116039 8.96096 -0.000566684 8.87502 0.000620729 8.70312C0.0500586 1.54738 1.70283 -5.55964e-07 9 0C16.2972 5.55964e-07 17.9499 1.54738 17.9994 8.70313C18.0006 8.87502 18.0012 8.96097 17.9904 9.0597Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75005 5.27623C9.75005 4.91522 9.41424 4.62256 9 4.62256C8.58576 4.62256 8.24996 4.91522 8.24996 5.27623V9.79871C8.24996 10.1597 8.58576 10.4524 9 10.4524C9.41424 10.4524 9.75005 10.1597 9.75005 9.79871V5.27623ZM9 11.3062C8.58576 11.3062 8.24996 11.5989 8.24996 11.9599V12.16C8.24996 12.521 8.58576 12.8137 9 12.8137C9.41424 12.8137 9.75005 12.521 9.75005 12.16V11.9599C9.75005 11.5989 9.41424 11.3062 9 11.3062Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
